<template>
  <div class='finance-income'>
    <div class='nav'>
      <el-form :model='form' label-width='90px' :inline='true' class='demo-form-inline flex1'>
        <el-form-item label='应收承运商:'>
          <el-input v-model='form.name' size='mini' placeholder='请输入应收承运商名称'></el-input>
        </el-form-item>

        <el-form-item label='月份:'>
          <el-date-picker
            v-model='form.time'
            type='month'
            size='mini'
            placeholder='请选择月份'
            value-format='yyyy-MM-dd'>
          </el-date-picker>
        </el-form-item>

        <el-form-item label='发票类型:'>
          <el-select v-model='form.type' filterable placeholder='请选择发票类型' size='mini'
                     value-key='id'>
            <el-option v-for='item in invoiceTypeOption' :label='item.classaName'
                       :value='item' :key='item.id'></el-option>
          </el-select>
        </el-form-item>
        <!--        <el-form-item label="审核状态:">-->

        <!--          <el-select v-model="form.status" size="mini" placeholder="请选择状态">-->
        <!--            <el-option label="待审核" value="1"></el-option>-->
        <!--            <el-option label="已通过" value="2"></el-option>-->
        <!--            <el-option label="未通过" value="3"></el-option>-->
        <!--            <el-option label="已取消" value="4"></el-option>-->
        <!--          </el-select>-->
        <!--        </el-form-item>-->

        <el-form-item>
          <el-button size='small' class='searchBtn' @click='searchBtn'>查询</el-button>
          <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>
          <el-button size='small' type='primary' @click='addBtn'>新增</el-button>
        </el-form-item>

      </el-form>
    </div>
    <div class='content'>
      <div class='tableContainer'>
        <el-table
          v-loading='tableLoad'
          :data='TableDatas'
          style='width: 100%'
          row-key='id'
          border
          :header-cell-style="{background:'#E8E8E8',color:'#3B3B3B'}"
        >
          <el-table-column type='index' label='序号' width='50px' align='center' />
          <el-table-column label='应收委托商' prop='customerName' align='center' />
          <el-table-column label='金额(元)' prop='amount' align='center' />

          <el-table-column label='月份' prop='month' align='center' />
          <el-table-column label='税点' prop='taxPoint' align='center' />
          <el-table-column label='发票类型' prop='invoiceTypeName' align='center' />
          <el-table-column label='状态' prop='status' align='center'>
            <template slot-scope='scope'>
              {{ scope.row.status|statusFormat }}
            </template>
          </el-table-column>
          <el-table-column label='操作' width='250' align='center'>
            <template slot-scope='scope'>
              <div>
                <el-button size='mini' class='searchBtn' type='primary'
                           @click='detailClick(scope.$index, scope.row)'>详情
                </el-button>
                <el-button v-if='scope.row.status === 0 || scope.row.status === 3' size='mini'
                           class='yellow-bg'
                           @click='modifyClick(scope.$index, scope.row)'>修改
                </el-button>
                <el-button v-if='scope.row.status !== 1' size='mini' type='primary'
                           :loading='invoicingLoading'
                           @click='submitBillingClick(scope.row)'>
                  提交到财务审核
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class='paginationContainer'>
        <el-pagination
          background
          :page-sizes='[10, 20, 30, 40]'
          layout='total, sizes, prev, pager, next, jumper'
          :total='total'
          @size-change='contractSizeChange'
          @current-change='contractCurrentChange'
          :current-page.sync='form.page'
          :page-size='form.rows'
        />
      </div>
    </div>
    <el-dialog :title='dialogTitle' :visible.sync='addflag' width='700px' center
               @close='dialogClose'>
      <div class='add'>
        <div class='baseInfo'>
          <div class='baseInfoContent'>
            <el-form :model='modifyData' label-width='110px' label-position='right' :rules='rules'
                     ref='ruleForm' class='demo-ruleForm'>
              <div-border label='基础信息' prop='plan'>
                <div class='yang'>
                  <el-form-item label='委托商:' prop='companyId'>
                    <el-select v-model='modifyData.companyId' filterable placeholder='请选择委托商'
                               size='mini' value-key='id'>
                      <el-option v-for='(item,index) in companyList' :label='item.name'
                                 :value='item' :key='`${index}sds`'></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label='月份:' prop='month'>
                    <el-date-picker
                      v-model='modifyData.month'
                      type='month'
                      size='mini'
                      placeholder='请选择月份'
                      value-format='yyyy-MM'>
                    </el-date-picker>
                  </el-form-item>

                  <el-form-item label='金额:' prop='amount'>
                    <el-input
                      placeholder='请输入金额'
                      v-model='modifyData.amount' size='mini'>
                    </el-input>
                  </el-form-item>
                  <el-form-item label='税点:' prop='taxPoint'>
                    <el-input
                      placeholder='请输入税点'
                      v-model='modifyData.taxPoint' size='mini'>
                    </el-input>
                  </el-form-item>
                  <el-form-item label='发票类型:' prop='type'>
                    <el-select v-model='modifyData.type' filterable placeholder='请选择发票类型'
                               size='mini' value-key='id'>
                      <el-option v-for='(item,index) in invoiceTypeOption' :label='item.classaName'
                                 :value='item' :key='item.id'></el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div-border>
              <!-- <div-border label="上传文件" >
                <el-form-item style="margin-top:15px;margin-left: 43px ">
                  <div class="imgUp">
                    <div class="imgLength"><span>{{modifyData.img.length}}/5</span></div>
                    <el-upload
                      ref="upload"
                      list-type="picture-card"
                      action="#"
                      :auto-upload="false"
                      accept="image/png, image/jpeg, image/jpeg, image/bmp, image/gif"
                      :before-upload="beforeAvatarUpload"
                      :on-change="uploadChange"
                      :on-remove="handleRemove"
                      :on-preview="handlePictureCardPreview"

                      :file-list="modifyData.img"
                      :limit="5"
                    >
                      <i class="el-icon-plus"/>
                    </el-upload>

                  </div>
                </el-form-item>
              </div-border> -->

              <div-border label='上传附件'>
                <el-form-item style='margin-top:15px;'>
                  <div class='imgUp'>
                    <el-upload
                      ref='upload'
                      class='upload-demo'
                      :action='uploadUrl'
                      :auto-upload='true'
                      :before-upload='beforeAvatarUpload'
                      :show-file-list='false'
                      :data='uploadData'
                      :on-change='uploadChange'
                      :on-success='(res) => uploadImgFun(res, 2)'
                      :file-list='modifyData.img'
                      :limit='5'
                    >
                      <!--                    <i class="el-icon-plus"/>-->
                      <el-button size='small' type='primary'>点击上传</el-button>
                      <div slot='tip' style='margin-top: 6px;margin-left: 10px'>支持扩展名：.rar .zip .doc
                        .docx .pdf .jpg...
                      </div>
                    </el-upload>
                    <div v-for='(item,index) in modifyData.img'>
                      <div class='upload'>
                        <div
                          style='white-space:nowrap; text-overflow:ellipsis;overflow:hidden;width: 360px'>
                          {{ item.name }}
                        </div>
                        <div>
                          <i class='el-icon-zoom-in' @click='handlePictureCardPreview(item,index)'
                             v-if="item.name.substring(item.name.indexOf('.')) == '.jpeg'
                             ||item.name.substring(item.name.indexOf('.')) == '.png'
                             ||item.name.substring(item.name.indexOf('.')) == '.jpg'
                             || item.name.substring(item.name.indexOf('.')) == '.gif'"></i>
                          <i class='el-icon-upload2' @click='uploadClick(item,index)'></i>
                          <i class='el-icon-delete' @click='handleRemove(item,index)'></i></div>
                      </div>
                    </div>

                  </div>
                </el-form-item>
              </div-border>

            </el-form>
            <div class='btnContainer'>
              <el-button size='medium' class='searchBtn' :loading='addLoad' @click='addClick'>
                {{ dilogNumber === 1 ? '添加' : '修改' }}
              </el-button>
              <el-button size='medium' class='resetBtn' @click='dialogClose'>关闭</el-button>
            </div>
          </div>

        </div>

      </div>
      <el-dialog :visible.sync='dialogVisible' append-to-body>
        <img width='100%' :src='dialogImageUrl' alt=''>
      </el-dialog>
    </el-dialog>

    <el-dialog title='详情' :visible.sync='detailDialogVisible' width='623px' center>
      <div class='detail'>
        <div class='baseInfo'>
          <div class='baseInfoTitle'>
            <div class='line' />
            <span>基础信息</span>
            <p>{{ detailData.state }}</p>
          </div>
          <div class='baseInfoContent'>
            <el-form :model='detailData' label-position='left'>
              <el-form-item label='应收委托商:'>
                <span>{{ detailData.customerName }}</span>
              </el-form-item>
              <el-form-item label='月份:'>
                <span>{{ detailData.month }}</span>
              </el-form-item>
              <el-row>
                <el-col :span='12'>
                  <el-form-item label='税点:'>
                    <span>{{ detailData.taxPoint }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span='12'>
                  <el-form-item label='金额:'>
                    <span>{{ detailData.amount }}</span>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-form-item label='发票类型:'>
                <span>{{ detailData.invoiceTypeName }}</span>
              </el-form-item>

            </el-form>
          </div>
          <div class='operation'>
            <div class='operationTitle'>
              <div class='line' />
              <span>附件信息</span>
            </div>
            <div class='baseInfoContent' style='padding: 0 23px 10px 23px;'>
              <div style='display: flex;width: 100%' v-if='detailData.powerType !==0'>
                <el-form :model='detailData' label-position='left' style='width: 100%'>
                  <el-row :gutter='10' style='width: 100%' v-for='(item,index) in detailData.img'
                          :key='`${index}cvg`'>
                    <el-col :span='13'
                            style='white-space: nowrap;overflow: hidden;text-overflow: ellipsis;'>
                      {{ item.attachmentName }}
                    </el-col>
                    <el-col :span='7'>{{ item.uploadTime }}</el-col>
                    <el-col :span='2'>
                      <i class='el-icon-zoom-in' @click='handlePictureCardPreview(item,index)'
                         v-if="item.attachmentName.substring(item.attachmentName.indexOf('.')) == '.jpeg'
                             ||item.attachmentName.substring(item.attachmentName.indexOf('.')) == '.png'
                             ||item.attachmentName.substring(item.attachmentName.indexOf('.')) == '.jpg'
                             || item.attachmentName.substring(item.attachmentName.indexOf('.')) == '.gif'"></i>

                    </el-col>
                    <el-col :span='2'>
                      <i class='el-icon-download' @click='downloadClick(item.id)'></i>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
              <div v-else
                   style='font-weight: 700;margin: 10px 10px;cursor: pointer;display: block;width: 150px;'>
                暂无权限
              </div>
            </div>
          </div>
          <div class='operation'>
            <div class='operationTitle'>
              <div class='line' />
              <span>审核信息</span>
            </div>
            <div class='operationTable'>
              <!--              <steps :step-data="stepData" :step-state="stepState"/>-->
              <el-table :data='operationData' border
                        :header-cell-style="{background:'#E8E8E8',color:'#3B3B3B'}">
                <el-table-column prop='createTime' label='操作时间' align='center' width='160px' />
                <el-table-column prop='operateType' label='操作类型' align='center' />
                <el-table-column prop='operationName' label='操作人' align='center' />
                <el-table-column prop='remark' label='备注' align='center' />
              </el-table>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync='dialogVisible' append-to-body>
      <img width='100%' :src='dialogImageUrl' alt=''>
    </el-dialog>

    <!-- 提交开票 -->
    <submit-billing ref='submitBillingRef' @submitBilling='submitBilling' />
  </div>
</template>

<script>
  import {
    baseUrl,
    baseImgUrl,
  } from '@/config/env';
  import uploadImg from '@/components/uploadImg';
  import divBorder from '@/components/divBorder';
  import steps from '@/components/steps';
  import { customerInfoSelectList, getParam } from '@/service/getData';
  import {
    financeIncomeList,
    financeIncomeAdd,
    financeIncomeDetail,
    financeIncomeEdit,
    incomeSubmitInvoiceDetail,
    incomeSubmitInvoiceAdd,
  } from '@/service/financial';
  import { getSessionStore } from '@/config/mUtils';
  import SubmitBilling from '@/components/submitBilling';

  export default {
    components: {
      SubmitBilling,
      uploadImg,
      divBorder,
      steps,
    },
    data() {
      return {
        form: {
          name: '',
          type: '',
          number: '',
          customerNumber: '',
          company: '',
          time: '',
          status: '',
          page: 1,
          rows: 10,

        },
        dialogImageUrlList: [],
        uploadFlag: false,//替换
        uploadIndex: '',//替换索引
        uploadData: {
          fileType: '2',
        },
        total: 0,
        tableLoad: false,
        TableDatas: [],

        detailDialogVisible: false,
        addLoad: false,
        detailData: {},
        modifyData: {
          companyId: '',
          name: '',
          month: '',
          amount: '',
          taxPoint: '',
          type: '',
          attachmentIdStr: '',
          img: [],
        },
        stepData: [
          {
            title: '张三发起',
            time: '2021-9-30 14:09:23',
            state: '',
            remark: '',
          },
          {
            title: '财务部 张三通过',
            time: '2021-9-30 14:09:23',
            state: 'success',
            remark: '原因xxxxxx',
          },
          {
            title: '技术部 李四拒绝',
            time: '2021-9-30 14:09:23',
            state: 'failure',
            remark: '原因xxxxxx',
          },
          {
            title: '张三重新发起',
            time: '2021-9-30 14:09:23',
            state: '',
            remark: '',
          },
        ],
        operationData: [],
        companyList: [
          {
            companyId: '23233',
            companyName: 'zhi',
          },
          {
            companyId: '748737',
            companyName: 'shi',
          },
        ],
        invoiceTypeOption: [],//发票类型
        baseImgUrl: baseImgUrl + '/',
        uploadUrl: '',
        dialogTitle: '',
        dialogVisible: false,
        addflag: false,
        // 1 为添加 2 修改
        dilogNumber: 1,
        dialogImageUrl: '',
        rules: {
          companyId: {
            required: true,
            message: '请选择供应商',
            trigger: 'blur',
          },
          month: {
            required: true,
            message: '请选择月份',
            trigger: 'blur',
          },
          name: {
            required: true,
            message: '请选择应收委托',
            trigger: 'blur',
          },
          amount: {
            required: true,
            message: '请输入金额',
            trigger: 'blur',
          },
          type: {
            required: true,
            message: '请选择发票类型',
            trigger: 'blur',
          },
          taxPoint: {
            required: true,
            message: '请输入税点',
            trigger: 'blur',
          },
          img: {
            required: true,
            message: '请上传附件',
            trigger: 'blur',
          },

        },
        invoicingLoading: false,
        rowId: '',
      };
    },
    computed: {
      stepState() {
        return function(state) {
          switch (state) {
            case '':
              return 'wait';
            case 'success':
              return 'success';
            case 'failure':
              return 'error';
          }
        };
      },
    },
    filters: {
      statusFormat(status) {
        switch (status) {
          case 0:
            return '待提交开票';
          case 1:
            return '开票中';
          case 2:
            return '开票成功';
          case 3:
            return '开票失败';
        }
      },
    },
    created() {
      this.init();
    },
    methods: {
      init() {
        this.uploadUrl = baseUrl + '/web/attachmentFtp/upload';
        this._customerInfoSelectList();
        this._getParam();
        // this._incomeList();
      },
      addBtn() {
        // 1 为添加 2 修改
        this.dilogNumber = 1;
        this.dialogTitle = '新增价格审批';
        this.addflag = true;
      },
      searchBtn() {
        this.form.page = 1;
        this._incomeList();
      },
      resetBtn() {
        for (const argumentsKey in this.form) {
          this.form[argumentsKey] = '';
        }
        this.form.page = 1;
        this.form.rows = 10;

      },
      contractSizeChange(row) {
        this.form.rows = row;
      },
      contractCurrentChange(page) {
        this.page = page;
      },
      // 详情
      async detailClick(index, row) {
        this.detailDialogVisible = true;
        let res = await financeIncomeDetail(row.id);

        if (res.status !== 0) {
          return this.$message.error(res.message);
        }
        this.detailData = res.data;
        this.operationData = res.data.operateRecordList;
        this.$set(this.detailData, 'img', res.data.attachments);
      },
      async modifyClick(index, row) {
        // 1 为添加 2 修改
        this.dilogNumber = 2;
        this.dialogTitle = '修改';
        this.addflag = true;

        let res = await financeIncomeDetail(row.id);

        if (res.status !== 0) {
          return this.$message.error(res.message);
        }
        this.modifyData = res.data;
        var companyId = {};
        companyId.id = res.data.customerId;
        companyId.name = res.data.customerName;
        var type = {};
        type.id = res.data.invoiceType;
        type.classaName = res.data.invoiceTypeName;
        var imgs = [];
        for (var x of res.data.attachments) {
          var img = {};
          img.id = x.id;
          img.name = x.attachmentName;
          imgs.push(img);
        }

        this.$set(this.modifyData, 'companyId', companyId);
        this.$set(this.modifyData, 'type', type);
        this.modifyData.attachmentIdStr = '';
        this.$set(this.modifyData, 'img', imgs);


      },
      // rejectClick(){
      //   this.$confirm('确认要取消价格审批吗！', '提示', {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消',
      //     type: 'warning'
      //   }).then(() => {
      //   }).catch(() => {});
      // },
      beforeAvatarUpload(file) {
        // const TypeArr = ['image/jpeg', 'image/png', 'image/bmp', 'image/gif', 'image/jpg']
        // const isJPG =TypeArr.includes(file.type)
        const isLt10M = file.size / 1024 / 1024 < 10;
        // if (!isJPG) this.$message.error('上传图片只能为jpg/png/jpeg/bmp/gif格式')
        if (!isLt10M) this.$message.error('上传图片大小不能超过 10MB');

        // return isJPG && isLt10M
        return isLt10M;
      },
      uploadChange(file, fileList) {
        if (this.uploadFlag) {
          this.modifyData.img.splice(this.uploadIndex, 1, file);
        } else {
          this.modifyData.img = fileList;
          console.log(fileList);
        }
        if (Object.keys(file)
          .includes('response')) {
          if (file.response.status == -1) {
            this.modifyData.img.splice(this.modifyData.img.indexOf(file), 1);
          }
        }

      },
      handleRemove(item, index) {
        this.modifyData.img.splice(index, 1);
      },
      handlePictureCardPreview(item, index) {
        let token = getSessionStore('token');
        var url = baseUrl + '/web/attachmentFtp/download?attachmentId=' + (item.id || item.response.data.id) + '&access_token=' + token;
        this.dialogImageUrl = url;
        this.dialogVisible = true;
      },
      //外部上传方法，替换
      uploadClick(item, index) {
        this.uploadIndex = index;
        this.uploadFlag = true;
        this.$refs.upload.$refs['upload-inner'].handleClick();

      },
      //附件上传成功回调
      uploadImgFun(res, val) {
        if (res.status == 0) {
          this.$message.success(res.message);
          if (this.uploadFlag) {//如果为替换，得到索引值进行替换
            this.dialogImageUrlList.splice(this.uploadIndex, 1, { 'id': res.data.id });
            console.log(this.dialogImageUrlList);
            this.uploadFlag = false;
          } else {
            this.dialogImageUrlList.push({ 'id': res.data.id });
            console.log(this.dialogImageUrlList);
          }

        } else {
          this.$message.error(res.message);
          this.uploadFlag = false;

        }
      },
      //详情附件下载
      downloadClick(id) {
        let token = getSessionStore('token');
        window.location.href = baseUrl + '/web/attachmentFtp/download?access_token=' +
          token + '&attachmentId=' + id;
      },
      closeDialog() {
        this.dialogVisible = false;
      },
      addClick() {
        this.$refs.ruleForm.validate(async (valid, val) => {
          // if(Object.keys(val).length === 1) valid=true;
          if (valid) {
            // 1 为添加 2 修改
            if (this.dilogNumber === 1) {
              console.log('添加');
              this.modifyData.attachmentIdStr = '';
              this.dialogImageUrlList.forEach((item, index) => {
                if (this.dialogImageUrlList.length - 1 === index) {
                  this.modifyData.attachmentIdStr += item.id;
                } else {
                  this.modifyData.attachmentIdStr += item.id + ',';
                }
              });
              var param = {};
              param.customerId = this.modifyData.companyId.id;
              param.customerName = this.modifyData.companyId.name;
              param.amount = this.modifyData.amount;
              param.month = this.modifyData.month;
              param.taxPoint = this.modifyData.taxPoint;
              param.invoiceType = this.modifyData.type.id;
              param.invoiceTypeName = this.modifyData.type.classaName;
              param.attachmentIdStr = this.modifyData.attachmentIdStr;
              this.addLoad = true;
              let res = await financeIncomeAdd(param);
              console.log(res);
              this.addLoad = false;
              if (res.status !== 0) return this.$message.error(res.message);
              this.$message.success(res.message);
              this.addflag = false;
              this.searchBtn();
            } else {
              console.log('修改');
              this.modifyData.attachmentIdStr = '';
              this.modifyData.img.forEach((item, index) => {
                if (this.modifyData.img.length - 1 === index) {
                  this.modifyData.attachmentIdStr += (item.id || item.response.data.id);
                } else {
                  this.modifyData.attachmentIdStr += (item.id || item.response.data.id) + ',';
                }
              });
              var param = {};
              param.id = this.modifyData.id;
              param.customerId = this.modifyData.companyId.id;
              param.customerName = this.modifyData.companyId.name;
              param.amount = this.modifyData.amount;
              param.month = this.modifyData.month;
              param.taxPoint = this.modifyData.taxPoint;
              param.invoiceType = this.modifyData.type.id;
              param.invoiceTypeName = this.modifyData.type.classaName;
              param.attachmentIdStr = this.modifyData.attachmentIdStr;
              console.log(param);
              this.addLoad = true;
              let res = await financeIncomeEdit(param);
              this.addLoad = false;
              console.log(res);
              if (res.status !== 0) return this.$message.error(res.message);
              this.$message.success(res.message);
              this.addflag = false;
            }
            // this.$emit("addclose",false)
            for (const argumentsKey in this.modifyData) {
              if (argumentsKey == 'img') {
                this.modifyData[argumentsKey] = [];
              } else {
                this.modifyData[argumentsKey] = '';
              }

            }


          } else {
            return false;
          }
        });
      },
      dialogClose() {
        this.$refs.ruleForm.resetFields();
        this.addflag = false;
        // this.$emit("addclose",false)
      },
      async _incomeList() {
        let {
          name,
          time,
          type,
        } = this.form;
        this.tableLoad = true;
        let res = await financeIncomeList({
          customerName: name,
          month: time,
          invoiceType: (type.id || ''),
        });
        this.tableLoad = false;
        if (res.status !== 0) {
          return this.$message.error(res.message);
        }
        this.TableDatas = res.data.records;
        this.total = res.data.total;
      },
      async _customerInfoSelectList() {
        const res3 = await customerInfoSelectList();
        if (res3.status !== 0) return this.$message.error(res3.message);
        this.companyList = res3.data.map(item => {
          return {
            name: item.customer_name,
            id: item.id,
          };
        });

      },
      async _getParam() {
        let res = await getParam({ categoryCd: 'invoice_type' });
        if (res.status !== 0) return this.$message.error(res.message);
        this.invoiceTypeOption = res.data;
      },
      async submitBillingClick(row) {
        this.rowId = row.id;
        this.invoicingLoading = true;
        const {
          status,
          message,
          data,
        } = await incomeSubmitInvoiceDetail({
          id: row.id,
          customerId: row.customerId,
        });
        this.invoicingLoading = false;
        if (status !== 0) return this.$message.warning(message);
        this.$refs.submitBillingRef.invoicingOpen(data);
      },
      async submitBilling(invoiceManageList) {
        const {
          status,
          message,
        } = await incomeSubmitInvoiceAdd({
          id: this.rowId,
          invoiceManageList: [invoiceManageList],
        });
        this.$refs.submitBillingRef.invoicingLoading = false;
        if (status !== 0) return this.$message.warning(message);
        this.$refs.submitBillingRef.invoicingClose();
        this.$message.success(message);
        this._incomeList();
      },
    },
  };
</script>


<style lang='scss' scoped>
  .finance-income {
    /*width:100%;*/
    padding: 20px 15px 0 25px;
    height: 100%;
    /*overflow: auto;*/
    .nav {
      /*width:100%;*/
      display: flex;
      /*align-items: center;*/
      /*height:30px;*/
      overflow: hidden;

      .flex1 {
        flex: 1;
      }

      .el-input {
        width: 150px;
      }

      .el-select {
        width: 150px;
      }

      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
    }

    ::v-deep .detail {
      .el-form-item__label {
        font-weight: 700;
      }

      .line {
        width: 12px;
        height: 32px;
        background-color: rgba(51, 84, 131, 100);
        margin-right: 10px;
      }

      .line + span {
        font-size: 16px;
        color: rgba(51, 84, 131, 100);
        font-weight: 600;
      }

      width: 100%;
      padding: 10px 0 20px 20px;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(249, 166, 6);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;

          .center-f {
            display: flex;
          }

          .el-form-item {
            margin-bottom: 2px;

            .el-form-item__label {
              /*color: #060606;*/
            }
          }


        }
      }

      .operation {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Table {
          width: 100%;
          margin-top: 10px;
          padding-right: 20px;
        }
      }
    }

    ::v-deep .add {

      .el-form-item__label {
        font-weight: 700;
      }

      .line {
        width: 12px;
        height: 32px;
        background-color: rgba(51, 84, 131, 100);
        margin-right: 10px;
      }

      .line + span {
        font-size: 16px;
        color: rgba(51, 84, 131, 100);
        font-weight: 600;
      }

      width: 100%;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;

          .center-f {
            display: flex;
          }

          .yang {
            .el-form-item {
              .el-form-item__error {
                left: 40px;
              }

              margin-bottom: 15px;

              .el-form-item__label {
                width: 150px !important;
              }

              .el-input {
                width: 430px;
              }

              .el-textarea {
                width: 250px;

              }
            }

          }

          .el-upload-list__item {
            width: 100px;
            height: 100px;
          }

          .el-upload--picture-card {
            width: 100px;
            height: 100px;
            line-height: 100px;
          }

          .imgUp {
            display: flex;
            flex-direction: column;

            .imgLength {
              display: flex;
              align-items: center;
              width: 100%;

              span {
                margin-left: auto;
                color: rgb(183, 183, 183);
                font-size: 16px;
              }
            }
          }
        }
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 13px;
        margin-top: 20px;

        button {
          margin: 0 15px;
        }
      }
    }

    .baseInfo {
      display: flex;
      flex-direction: column;

      &Content {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 20px 23px 0 23px;
        font-size: 14px;

        .center-f {
          display: flex;
        }

        .yang {
          .el-form-item {
            .el-form-item__error {
              left: 40px;
            }

            margin-bottom: 15px;

            .el-form-item__label {
              width: 150px !important;
              /*color: #060606;*/
            }

            .el-input {
              width: 430px;
            }

            .el-textarea {
              width: 250px;

            }
          }

        }

        .el-upload-list__item {
          width: 100px;
          height: 100px;
        }

        .el-upload--picture-card {
          width: 100px;
          height: 100px;
          line-height: 100px;
        }

        .imgUp {
          /*display: flex;*/
          /*flex-direction: column;*/
          /*.imgLength{*/
          /*  display: flex;*/
          /*  align-items: center;*/
          /*  width:100%;*/
          /*  span{*/
          /*    margin-left:auto;*/
          /*    color: rgb(183, 183, 183);*/
          /*    font-size: 16px;*/
          /*  }*/
          /*}*/
          .upload-demo {
            display: flex;
          }

          .upload {
            font-size: 17px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            i {
              margin-right: 10px;
            }

            i:hover {
              color: #00e1ff;
            }
          }
        }
      }
    }

    .baseInfoContent i {
      margin-right: 10px;
    }

    .baseInfoContent i:hover {
      color: #00e1ff;
      cursor: pointer;
    }

    ::v-deep {
      .el-dialog__header {
        padding: 9px 20px 9px;
        background: #335483;
      }

      .el-dialog__title {
        line-height: 24px;
        font-size: 14px;
        color: #FFFFFF;
      }

      .el-dialog__headerbtn {
        top: 9px;
      }

      .el-dialog__headerbtn .el-dialog__close {
        color: #fff;
        font-size: 25px;
      }

      .el-dialog__body {
        padding: 0;
        overflow: auto;
        max-height: 75vh;
        color: #606266;
      }
    }
  }

  ::v-deep {
    .el-form--inline .el-form-item {
      margin-bottom: 5px;
    }
  }
</style>
